<template>
  <div>
    <el-group-title :title="title">
      <template slot="groupTitle">
        <el-table
          :data="tableData"
          :fit="true"
          @selection-change="selectionChange"
          border
          class="multifunctional-table dic-sub-table-style01"
        >
          <el-table-column
            type="selection"
            width="50"
            v-if="showCheckBox"
            align="center"
            header-align="center"
          />
          <el-table-column
            type="index"
            width="50"
            label="序号"
            align="center"
            v-if="showIndex"
          >
            <template #default="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <template v-for="(table, index) in tableHead">
            <el-table-column
              :key="index"
              :label="table.label"
              :width="table.width"
              :min-width="table.minWidth"
              :prop="table.prop"
              :align="table.align"
              :header-align="table.headerAlign"
              :show-overflow-tooltip="true"
              :formatter="table.formatter"
              v-if="!table.template"
            >
              <template slot-scope="scope">
                <p v-if="table.slot === 'thawTime'">
                  <span v-if="scope.row.state == '1'">
                    {{ scope.row.thawTime }}</span
                  >
                  <span v-else>{{ scope.row.updateTime }}</span>
                </p>
                <p v-if="table.slot === 'opp'">
                  <a
                    v-if="Number(scope.row.uploadId) !== 0"
                    class="icon-ccui-link"
                    @click="download(scope.$index, scope.row)"
                    title="点击下载"
                  ></a>
                  <span v-else></span>
                </p>
                <span v-else-if="table.slot === 'size'">
                  {{ (scope.row.fileSize / 1024).toFixed(0) }}kb
                </span>
                <slot
                  v-else-if="table.slot"
                  :row="scope.row"
                  :$index="scope.$index"
                  :name="table.slot"
                >
                </slot>
                <template v-else>
                  <span
                    v-if="scope.row.required && scope.row.prop === table.prop"
                    style="color: #ff0000"
                    >*</span
                  >
                  {{ scope.row[table.prop] || "" }}
                  <span
                    v-if="
                      scope.row.fileinfoType === '02' &&
                        scope.row.prop === table.prop
                    "
                    style="color: #ff0000"
                    >（含增值税一般纳税人红章页面）</span
                  >
                </template>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </template>
    </el-group-title>
    <!--   分页功能  -->
    <div class="table-footer" style="height:30px" v-if="type === 1">
      <div class="ccui-table-footer">
        <div id="ccui-paging">
          <el-pagination
            :total="tableData.length"
            :page-size="pageSize"
            :current-page="pageNo"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleGoPage('none')"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addUrlPerFix } from "@/basa/utils";
export default {
  name: "supplier-table",
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    tableHead: {
      type: Array,
      default: () => []
    },
    showCheckBox: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10
    };
  },
  methods: {
    selectionChange(selection) {
      this.$emit("selectionChange", selection);
    },
    download(index, row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/scpma/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.getStatusInfo();
    },
    handleCurrentChange(newNum) {
      this.pageNo = newNum;
      this.getStatusInfo();
    },
    handlePrev() {
      --this.props_pageNo;
      (this.pageNo = this.props_pageNo), (this.pageSize = this.props_pageSize);
      this.getStatusInfo();
    },
    handleNext() {
      ++this.props_pageNo;
      (this.pageNo = this.props_pageNo), (this.pageSize = this.props_pageSize);
      this.getStatusInfo();
    },
    handleGoPage(val) {
      this.props_pageNo = 1;
      if (val !== "none") {
        this.props_pageSize = val;
        // setSessionItem("pageSize", this.tableName, val);
      }
      (this.pageNo = this.props_pageNo), (this.pageSize = this.props_pageSize);
      this.getStatusInfo();
    }
  }
};
</script>

<style scoped></style>
